import React, { createContext, useContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [usuarioId, setUsuarioId] = useState(null);

  // On component mount, check localStorage for saved user and usuarioId
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    const savedUsuarioId = localStorage.getItem("usuarioId");
    
    if (savedUser) {
      try {
        // Verificar que savedUser sea una cadena JSON válida
        if (savedUser !== "[object Object]" && savedUser.trim() !== "") {
          setUser(JSON.parse(savedUser));
        } else {
          // Si hay datos corruptos, limpiar localStorage
          localStorage.removeItem("user");
        }
      } catch (error) {
        console.error("Error parsing user data from localStorage:", error);
        // Limpiar datos corruptos
        localStorage.removeItem("user");
      }
    }
    if (savedUsuarioId) {
      setUsuarioId(savedUsuarioId);
    }
  }, []);

  const login = (userData) => {
    try {
      // Verificar que userData sea un objeto válido
      if (userData && typeof userData === 'object') {
        // Save user to state and localStorage
        setUser(userData);
        localStorage.setItem("user", JSON.stringify(userData));
        
        // Save usuarioId if provided
        if (userData.usuarioId) {
          setUsuarioId(userData.usuarioId);
          localStorage.setItem("usuarioId", userData.usuarioId);
        }
      } else {
        console.error("Invalid user data provided to login function");
      }
    } catch (error) {
      console.error("Error saving user data to localStorage:", error);
    }
  };

  const logout = () => {
    // Clear user from state and localStorage
    setUser(null);
    setUsuarioId(null);
    localStorage.removeItem("user");
    localStorage.removeItem("usuarioId");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("username");
    localStorage.removeItem("userName");
    localStorage.removeItem("isAuthenticated");
  };

  return (
    <UserContext.Provider value={{ user, usuarioId, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};